import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import EyeOnIcon from "../assets/icons/EyeOn";
import EyeOffIcon from "../assets/icons/EyeOff";
import { useController, } from "react-hook-form";
import { ErrorMessage } from "../error";
import { TextField } from "../text-field";
import formatWithMask from "../utils/formatWithMask";
const SSNField = (props) => {
    const { form, name = "ssn", showBootstrap = false, disabled, className, variant = "outlined", } = props;
    const { field, fieldState } = useController({
        control: form.control,
        name: name,
        ...(disabled !== undefined && { disabled }),
    });
    const [ssn, setSSN] = useState({
        masked: "",
        unmasked: "",
        obfuscated: "",
    });
    const ssnInputId = React.useId();
    const [selection, setSelection] = useState(null);
    const [showSSN, setShowSSN] = useState(false);
    const [maskedSSN, setMaskedSSN] = useState(field.value ?? "");
    const mask = [
        [/\d/],
        [/\d/],
        [/\d/],
        [/\d/],
        [/\d/],
        [/\d/],
        [/\d/],
        [/\d/],
        [/\d/],
    ];
    const obfuscationCharacter = "•";
    const onFieldChange = (e) => {
        if (e.target.name === name && ssn.unmasked != "") {
            if (e.target.value.length > ssn.masked.length) {
                const ssnValue = e.target.value.slice(-1);
                e.target.value = ssn.unmasked.concat(ssnValue);
            }
            else if (e.target.value.length === ssn.masked.length - 1) {
                e.target.value = ssn.unmasked.slice(0, -1);
            }
        }
        field.onChange(e);
    };
    // Wrapper for onBlur - react-hook-form handles blur automatically
    const handleBlurWrapper = () => {
        field.onBlur();
    };
    useEffect(() => {
        if (!selection)
            return; // prevent running on start
        const inputElement = document.getElementById(ssnInputId);
        if (!inputElement)
            return; // guard against null element
        const { start, end } = selection;
        inputElement.focus();
        inputElement.setSelectionRange(start, end);
    }, [selection, ssnInputId]);
    const setSSNPosition = (e) => {
        setSelection({
            start: e.target.value.length,
            end: e.target.value.length,
        });
    };
    useEffect(() => {
        setMaskedSSN(field.value ?? "");
    }, [field.value]);
    useEffect(() => {
        setSSN(formatWithMask({
            text: maskedSSN,
            mask,
            obfuscationCharacter,
        }));
    }, [maskedSSN]);
    return (_jsxs(_Fragment, { children: [!showBootstrap && (_jsxs(_Fragment, { children: [_jsx(TextField, { className: className, variant: variant, value: ssn.masked, id: ssnInputId, name: name, label: "Social Security number", onBlur: handleBlurWrapper, onChange: onFieldChange, type: "text", maxLength: 9, disabled: field.disabled ?? disabled, onFocus: () => setSSNPosition({ target: { value: ssn.masked } }), fullWidth: true, inputMode: "numeric", error: fieldState.error?.message, noAsterisk: true }), fieldState.error && (_jsx(ErrorMessage, { className: "ml-25 error", children: fieldState.error.message }))] })), showBootstrap && (_jsx(TextField, { className: className, variant: variant, value: showSSN ? ssn.masked : ssn.obfuscated, id: ssnInputId, name: name, label: "Social Security number", onBlur: handleBlurWrapper, onChange: onFieldChange, placeholder: "Enter Social Security number", type: "text", maxLength: 9, disabled: field.disabled ?? disabled, onFocus: () => setSSNPosition({
                    target: { value: showSSN ? ssn.masked : ssn.obfuscated },
                }), fullWidth: true, inputMode: "numeric", required: true, error: fieldState.error?.message, noAsterisk: true, endIcon: _jsx("button", { type: "button", onClick: (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setShowSSN(!showSSN);
                    }, className: "p-0 m-0 border-0 bg-transparent cursor-pointer hover:opacity-70 focus:outline-none inline-flex items-center justify-center", "data-testid": showSSN ? "ssnEye" : "ssnEyeSlash", "aria-label": showSSN ? "Hide SSN" : "Show SSN", children: showSSN ? (_jsx(EyeOnIcon, { className: "w-6 h-6" })) : (_jsx(EyeOffIcon, { className: "w-6 h-6" })) }) }))] }));
};
export default React.memo(SSNField);
//# sourceMappingURL=SSNField.js.map